import React, { useCallback, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },

  paper: {
    width: 400,
    backgroundColor: "white",
    borderRadius: "20px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const EditSearchModal = ({
  editSearchModal,
  handleEditSearchApply,
  handleEditSearchModalClose,
  previousSearchTerm,
}) => {
  const classes = useStyles();

  const [newSearchTerm, setNewSearchTerm] = useState("");
  useEffect(() => {
    setNewSearchTerm(previousSearchTerm);
  }, [previousSearchTerm]);

  const handleQueryPartChange = e => {
    const newSearchTerm = e.target.value;
    setNewSearchTerm(newSearchTerm);
  };

  const handleApply = useCallback(() => {
    handleEditSearchApply(newSearchTerm);
  }, [newSearchTerm, handleEditSearchApply]);

  const onKeyDown = useCallback(
    e => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleEditSearchApply(newSearchTerm);
      }
    },
    [newSearchTerm, handleEditSearchApply],
  );

  const handleClose = useCallback(() => {
    handleEditSearchModalClose();
    setNewSearchTerm(previousSearchTerm);
  }, [previousSearchTerm, handleEditSearchModalClose]);

  return (
    <Modal open={editSearchModal} className={classes.modal}>
      <div className={classes.paper}>
        <h3>Edit Search Term</h3>
        <TextField
          fullWidth
          value={newSearchTerm}
          onChange={handleQueryPartChange}
          onKeyDown={onKeyDown}
          style={{ margin: "0 0 15px 0" }}
        />
        <Button variant="contained" onClick={handleApply}>
          Apply
        </Button>
        <Button onClick={handleClose}>Cancel</Button>
      </div>
    </Modal>
  );
};

export default EditSearchModal;
